import { useRef } from "react";
import { UserStoryDto } from "../../dto/UserStoryDto";
import { ClassicyIcon } from "../components/icon/ClassicyIcon";
import { useUserStories } from "../context/UserStoriesContext";

interface VisitorStoriesWindowProps {
  onOpenStory: (story: UserStoryDto) => void;
}

export default function VisitorStoriesWindow({
  onOpenStory,
}: VisitorStoriesWindowProps) {
  const { stories } = useUserStories();
  const containerRef = useRef<HTMLDivElement>(null);

  // Calculate icon positions in grid (top-left to bottom-right)
  const iconSize = 128; // User story icons are 128px

  const getIconPosition = (index: number): [number, number] => {
    const cols = 6; // Icons per row
    const iconWidth = 192;
    const iconHeight = 180;
    const paddingX = 28;
    const paddingY = 72;

    const col = index % cols;
    const row = Math.floor(index / cols);

    return [
      paddingX + col * iconWidth + col * paddingX,
      row * paddingY + row * iconHeight,
    ];
  };

  return (
    <div
      ref={containerRef}
      style={{ position: "relative", width: "100%", height: "100%" }}
    >
      {stories.map((story, index) => (
        <ClassicyIcon
          key={story.id}
          appId={`story-${story.id}`}
          name={story.titleDE || "Story"}
          icon={story.visualUrl || "/assets/icons/default-story-icon.png"}
          label={story.titleDE}
          size={iconSize}
          fontSize={16}
          position={getIconPosition(index)}
          onClickFunc={() => onOpenStory(story)}
        />
      ))}
    </div>
  );
}
